export const TEXT_RESET = "Reset";
//LOGIN
export const stringEmail = "Email";
export const stringPassword = "Password";
export const rememberMe = "Remember Me";
export const forgotPassword = "Forgot Password?";
export const rememberPassword = "Remember password?";
export const signIn = "Sign In";
export const reLogIn = "Re-login";
export const logIn = "Log In";
export const signOut = "Sign Out";
export const setupPassword = "Set Up Password";
export const enterPasswordStr = "Enter your password";
export const enternPasswordStr = "Enter new password";
export const nPasswordStr = "New password";
export const entercPasswordStr = "Enter current password";
export const cPasswordStr = "Current password";
export const confirmnPasswordStr = "Confirm new password";
export const confirmPasswordStr = "Confirm your password";
export const errorMatchingPassword = "Password doesn’t match.";
export const passwordRuleLength = "The password must be at least 8 characters.";
export const passwordRuleLeterDigit = "The password must contain at least:";
export const passwordRuleDetail = ["one (1) letter: a-z", "one (1) digit (0-9)"];
export const submitBtn = "Submit";
export const sendEmail = "Send Email";
export const resetPassword = "Reset Password";
export const forgot = "Forgot Password";
export const forgotError = "The entered email cannot be found. Please try again.";
export const changePassword = "Change Password";
export const errAtLeast8CharMsg = "The password must be at least 8 characters.";
export const errContainAtLeastLetterAndDigitMsg = "Must contain at least one letter and one digit.";
export const changePasswordSuccessfully = "Password changed successfully.";
export const pleaseConfirmNewPassword = "Please confirm your new password.";
export const pleaseEnterCurrentPassword = "Please enter your current password.";
export const enterYourEmail = "Enter your email address";
export const emailAddress = "Email address";
export const forgotDes = "We’ll send a reset password link to your email address shortly. Please enter your email.";
export const owner = "© 2025 Rectangle Sheetmetal. All rights reserved.";
export const stringCancel = "Cancel";
export const confirmSignOut = "Confirm Sign Out";
export const confirmChangePassword = "Change Password";
export const confirmSignOutMessage = "Are you sure you want to sign out?";
export const confirmChangePasswordMessage = "Are you sure you want to change password?";
export const confirmText = "Confirm";
export const confirmTitle = "Confirmation";
export const confirmReLogin = "Your password changed successfully. Please help to re-login with new password.";
export const yourSessionExpired = "Your login session has expired. Please log in again.";
export const stringWarning = "Warning";
export const setupPasswordSuccessfully = "Password updated successfully.";
export const resetPasswordSuccessfully = "Password reset successfully.";
export const tokenNotFound = "Token not found.";
export const sendEmailMessageSuccessfully = "The reset password mail sent successfully.";
export const incorrectEmailOrPassword = "Incorrect email or password. Please try again.";
export const SETUP_LINK_EXPIRED = "Link has been expired. Please contact Rectangle admin for further support.";

//Profile
export const stringSave = "Save";
export const stringEditProfile = "Edit Profile";
export const avatarValidation = "Must be a .JPG or .PNG file smaller than 2MB.";
export const stringUploadImage = "Upload Image";
export const stringRemove = "Remove";
export const firstName = "First name";
export const lastName = "Last name";
export const mobilePhone = "Mobile phone";
export const stringChangePassword = "Change Password";
export const firstNameValidation = "First name can contain letters, with a max length of 30.";
export const lastNameValidation = "Last name can contain letters, with a max length of 30.";
export const mobilePhoneValidation = "Wrong phone number format.";
export const thisFieldIsRequired = "This field is required.";
export const yourProfileChangedSuccessfully = "Your profile changed successfully.";
export const editProfile = "Edit Profile";

// Site Sketches
export const SITE_SKETCHES = "Site Sketches";
export const MAJOR_PROJECTS = "Major Projects";
export const IN_PRODUCTION = "In Production";
export const SEARCH_PLACEHODER = "Search by Job Code, Project Name, P.O Number, Job Address";
export const SEARCH_PLACEHODER_MAJOR_PROJECT = "Search by Project Name, Project Address, Company";
export const SEARCH_PLACEHODER_MAJOR_PROJECTS_JOBS_LIST = "Search by Job Code, Job Code - Part No.";
export function couldNotLoadImageDueToAllowedFile(allowedFileExtension: string[]): string {
  return `Could not load image. Only ${allowedFileExtension.join(", ")} files are allowed. Please try again.`;
}
export function couldNotLoadImageDueToFileSize(maxFileSizeMB: number): string {
  return `Could not load image, the maximum size is ${maxFileSizeMB}MB. Please try again.`;
}
export const UPLOAD_AVATAR = "Upload avatar";
export const MENU = "MENU";
export const PROFILE = "PROFILE";
export const TOTAL_SKETCHES = "total sketches";
export const TOTAL_SKETCH = "total sketch";
export const ORDER_BY = "Order By";
export const PICK_UP_DELIVERY = "Pick-up/Delivery";
export const JOB_ID = "Job ID";
export const SKETCH_NO = "Sketch No.";
export const PROJECT_ADDRESS = "Project Address";
export const PO_NO = "P.O No.";
export const ORDER_DATE = "Order Date";
export const DOWNLOAD = "Download";
export const SITE_SKETCHES_CONFIG_TYPE = "SiteSketch";

// Major Project
export const FILTER_TITLES = [
  {
    key: "drawingNumbers",
    name: "Drawing Number"
  },
  {
    key: "statuses",
    name: "Job Status"
  },
  {
    key: "jobLocations",
    name: "Job Location"
  },
  {
    key: "jobCodes",
    name: "Job Code"
  },
  {
    key: "deliveryNumbers",
    name: "Delivery Docket"
  }
];
export const START_DATE = "Start Date";
export const DUE_DATE = "Due Date";
export const JOB_LOCATION = "Job Location";
export const DRAWING = "Drawing";
export const EXPORT_CSV_SUCCESSFULLY = "Export CSV successfully.";
export const EXPORT_CSV_FILE_NAME = "major_project_jobs_list_";
export const VIEW_JOBS = "View Jobs";
export const VIEW_ITEMS = "View Items";
export const LAST_ACTIVITY_DATE = "Last Activity Date";
export const JOBS = "Jobs";
export const TOTAL_JOB = "total job";
export const TOTAL_JOBS = "total jobs";
export const SEARCH_BY_PROJECT_NAME = "Search by Project Name";
export const PROJECT = "Project";
export const PROJECT_ID = "Project ID";
export const VIEW_JOB_ITEMS = "View Job Items";
export const CSV_FILE_EXTENSION = ".csv";
export const JOB_STATUS = "Job Status";
export const PROGRESS = "Progress";
export const DELIVERY_CONFIRMED = "Delivery Confirmed";
export const ACTION = "Action";
export const FAIL_TO_FETCH_JOB_LIST_DATA = "Failed to fetch jobs list data:";
export const MAJOR_PROJECTS_CONFIG_TYPE = "MajorProject_Job";

//View Job Items Detail
export const JOB_ITEM_DETAIL_PAGE_HEADER = "Major Projects List - Jobs List - Job Items List";
export const JOB_ITEM_DETAIL_MOBILE_PAGE_HEADER = "Job Items List";
export const PROJECT_NAME = "Project Name";
export const JOB_CODE = "Job Code";
export const SEARCH_BY_PIECE_NUMBER = "Search by Piece Number";
export const DELIVERY_DOCKET = "Delivery Docket";
export const TEXT_CLEAR = "Clear";
export const TEXT_APPLY = "Apply";
export const UI_CONFIG = "UI Config";
export const TOTAL_ITEMS = "total items";
export const TOTAL_ITEM = "total item";
export const TOTAL_PROJECT = "total project";
export const TOTAL_PROJECTS = "total projects";
export const EXPORT_CSV = "Export CSV";
export const PIECE_NUMBER = "Piece Number";
export const QUANTITY = "Quantity";
export const READY_QTY = "Ready Qty";
export const DELIVERED_QTY = "Delivered Qty";
export const STATUS = "Status";
export const DESCRIPTION = "Description";
export const TEXT_COMPANY = "Company";
export const TEXT_PROJECTNAME = "Project Name";
export const READY_DATE = "Ready Date";
export const DELIVERED_DATE = "Delivered Date";
export const TEXT_CSV = "CSV";
export const SOMETHING_WENT_WRONG = "Something went wrong. Please try again.";
export const TEXT_FILTERS = "Filters";
export const NO_RESULT_FOUND = "No result found. Try adjusting your search or filter to find what you’re looking for.";

//Query String on URL for get method
export const TOKEN_QUERY = "token";

//View Project Items Detail
export const PROJECT_ITEM_DETAIL_PAGE_HEADER = "Major Projects List - Project Items List";
export const DRAWING_NUMBER = "Drawing Number";
export const LOCATION = "Location";
export const ITEM_STATUS = "Item Status";
export const PROJECT_ITEM_DETAIL_MOBILE_PAGE_HEADER = "Project Items List";
export const READY = "Ready";
export const DELIVERED = "Delivered";
export const VIEW_LESS = "View less";
export const VIEW_MORE = "View more";
export const ACCOUNT_DELETED_OR_DEACTIVATED = "Your account has been inactivated or deleted. Please contact the staff to get support.";

//Auth string
export const EMAIL_ADDRESS_HAS_BEEN_CHANGED = "Your email address has been updated. Check your new email for a link to setup your new password.";

export const PDF_GENERATION_FAILED = "PDF generation failed.";
export const DOWNLOAD_DOCKET_SUCCESSFULLY = "Docket downloaded successfully.";
